import { Modal, Stack } from 'react-bootstrap';

import { ICollabModalProps } from './CollabModalContext';
import { ReactNode } from 'react';

export interface IAlreadyEditingModalData {
    leftFooterComponent?: ReactNode;
    onReadOnlyClick: () => void;
    onEditButtonClick: () => void;
}

export function AlreadyEditingModal(props: ICollabModalProps<IAlreadyEditingModalData, unknown>) {
    if (!props.open) return null;

    return (
        <Modal centered size="lg" show={props.open} backdrop={true}>
            <Modal.Header>
                <Modal.Title>Report is Read-only</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>You were previously editing this report in another session and didn't save.</p>
                <p>
                    Do you want to open this report in read-only mode or begin editing this report
                    here?
                </p>
                <p>
                    All unsaved changes made in your previous session will be permanently lost if
                    you choose to edit this report here
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Stack
                    direction="horizontal"
                    style={{
                        justifyContent: props.data?.leftFooterComponent
                            ? 'space-between'
                            : 'flex-end',
                        width: '100%',
                    }}
                >
                    {props.data?.leftFooterComponent && <>{props.data.leftFooterComponent}</>}
                    <div>
                        <button className="btn btn-default" onClick={props.data?.onReadOnlyClick}>
                            Open as Read-only
                        </button>
                        <button className="btn btn-default" onClick={props.data?.onEditButtonClick}>
                            Edit
                        </button>
                    </div>
                </Stack>
            </Modal.Footer>
        </Modal>
    );
}
